<template id="AdminTable">
  <div id="admin-details" class="table-container">
    <b-row class="my-1">
      <b-col></b-col>
      <b-col>
        <b-form-group
          label="Filter"
          label-cols-sm="8"
          label-align-sm="right"
          label-size="sm"
          label-for="filterInput"
          class="mb-0"
        >
          <b-input-group size="sm">
            <b-form-input
              v-model="filter"
              type="search"
              id="filterInput"
              placeholder="Type to Search"
            />
          </b-input-group>
        </b-form-group>
      </b-col>
    </b-row>
    <b-form-checkbox-group v-model="selected">
      <b-table
        sticky-header="640px"
        striped
        hover
        no-border-collapse
        primary-key="uniqueKey"
        :items="items"
        :filter="filter"
        sort-by="updatedAt"
        :sort-desc="true"
        :fields="defaultFields"
        >
        
      <template v-slot:head(status)>
        <status-icon statusState="Overall" />
      </template>
      
      <template v-slot:head(username)>
        <span class="fa fa-github" v-b-tooltip.hover title="Owner GitHub Username" />
      </template>
        
      <template v-slot:head(email) >
        <span class="fa fa-envelope" v-b-tooltip.hover title="Owner Email" />
      </template>
      
      <template v-slot:head(geckoID) >
        <span v-b-tooltip.hover title="Gecko ID">
          Gecko
        </span>
      </template>
      
      <!-- Table population. Different format to cleanly handle href population and
           global template logic. -->
      <template v-for="field in defaultFields" v-slot:[`cell(${field.key})`]="data">
        <template v-if="data.value">
          <template v-if="field.key === 'name'">
            <router-link :key="field.key" :to="`/org/${data.item.orgid}/repo/${data.item.repoid}`">{{ data.value }}</router-link>
          </template>
          <template v-else-if="field.key === 'status'">
              <status-icon :key="field.key" :statusState="data.value" />
          </template>
          <template v-else-if="field.key === 'email'">
            <a :key="field.key" :href="`mailto:${data.item.email}`" target="_blank">{{ data.value }}</a>
          </template>
          <template v-else-if="field.key === 'fileExchangeID'">
            <a :key="field.key" :href="`${data.item.fileExchange}`" target="_blank">{{ data.value }}</a>
          </template>
          <template v-else-if="field.key === 'geckoID'">
            <a :key="field.key" :href="`${data.item.gecko}`" target="_blank">{{ data.value }}</a>
          </template>
          <template v-else-if="field.key === 'proposalID'">
            <a :key="field.key"  :href="`${data.item.proposal}`" target="_blank">{{ data.value }}</a>
          </template>
          <template v-else-if="field.key === 'notes'">
            <span :key="field.key" v-b-tooltip.hover :title="data.item.notes" class="fa fa-file-text"/>
          </template>
          <template v-else>
            <a :key="field.key" >
              {{ data.value }}
            </a>
          </template>
        </template>
        <template v-else>
          <template v-if="field.key === 'status'">
            <status-icon :key="field.key" statusState="Follow Up" />
          </template>
          <template v-else>
            <span :key="data.item.id + field.key">-</span>
          </template>
        </template>
      </template>

      <template v-slot:table-colgroup="scope">
        <col
        v-for="field in scope.fields"
        :key="field.key"
        :style="{
          width:
          field.key === 'name' ||
          field.key === 'ownerName' ||
          field.key === 'ownerEmail' ||
          field.key === 'ownerGithubUsername'
              ? '50px' 
              : field.key === 'status' 
              ? '60px'
              : field.key === 'fileExchange'
              ? '100px'
                  : '180px',
            }"
          />
        </template>

        <template #empty="scope">
          {{ scope.emptyText }}
        </template>
      </b-table>
    </b-form-checkbox-group>
  </div>
</template>

<script>

import { StatusIcon } from "./icons";
import { yearMonthDayFormat } from "../common/time_utils";
import { DataBrew, DataExchange, DataPipeline, DataSync } from "aws-sdk";


export default {
  name: "AdminTable",
  props: {
    adminInfos: { type: Array },
    excludeColumns: {
      type: Array,
    },
  },
  components: {
    StatusIcon,
  },
  data: function() {
    return {
      filter: null,
      selected: [],
      defaultFields: [
        // add in commented-out fields as needed. they're all populated. 
        // { key: "repoid", sortable: true },
        { key: "name", sortable: true },
        { key: "status", sortable: true },
        { key: "ownername", label: "Owner", sortable: true },
        { key: "email", sortable: true },
        { key: "username", sortable: true },
        { key: "fileExchangeID", label: "File Ex.", sortable: true },
        // { key: "fileExchange", sortable: true },
        { key: "geckoID", label: "Gecko", sortable: true },
        // { key: "gecko", sortable: true },
        { key: "proposalID", label: "Proposal", sortable: true },
        // { key: "proposal", sortable: true },
        { key: "notes", sortable: true },
        { key: "updatedAt", label: "Updated", sortable: true },
      ],
      ncomplete: 0,
    };
  },
  methods: {
    checkComplete(obj) {
      if (obj.hasOwnProperty("status") && obj.status === 'Complete') {
        this.ncomplete++;
      }
      return true;
    },
    mergeObjects(obj1, obj2) {
      const merged = { ...obj1 };

      for (const key in obj2) {
        if (obj2.hasOwnProperty(key) && obj2[key] !== '') {
          merged[key] = obj2[key];
        }
      }
      return merged;
    },
    cleanAdminData(adminInfoList) {
      let preMergedItems = adminInfoList.filter(info => info.repoid !== 0).map((current) => {
          return {
            ...current,
            uniqueKey: `${current.repoid}`,
            updatedAt: yearMonthDayFormat(current.updatedAt),
          };
        });
        // Merge each repo with its ADDTIONAL_INFO by repoid and populate blank fields
        const mergedItems = {};

        preMergedItems.forEach(item => {

          const repoid = item.repoid;
          
          if (mergedItems.hasOwnProperty(repoid)) {
            // If it exists, merge the current item with the existing item
            mergedItems[repoid] = this.mergeObjects(mergedItems[repoid], item);
          } else {
            // If it doesn't exist, add the item to the mergedItems object
            mergedItems[repoid] = item;
          }
          this.checkComplete(item);
        });

        // Convert the mergedItems object back to an array
        this.$emit('ncomplete', this.ncomplete)
        return Object.values(mergedItems);
    }
  },
  computed: {
    items: function() {
      if (this.adminInfos) {
        return this.cleanAdminData(this.adminInfos);
      } else {
        return [];
      }
    },

    fields: function() {
      return this.defaultFields.filter((item) => {
        if (!this.excludeColumns) {
          return true;
        }
        const key = item.key || item;

        return !this.excludeColumns.includes(key);
      });
    },
  },
};
</script>

<style scoped>
.expandIcon {
  float: right;
}
.checkBox {
  margin: 0px;
}

</style>
